<h2>{{ 'LICENCE_CHECKING.restrictionCodes' | translateOrFallback:'Restriction Codes' }}</h2>

<vrm-basic-table [data]="dataSource" [columns]="columns">
  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.code' | translateOrFallback:'Code' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.code }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.description' | translateOrFallback:'Description' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.description }}</td>
  </ng-container>
</vrm-basic-table>
